import { Fragment, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dialog, Transition } from "@headlessui/react";
import { reduxForm, Field } from "redux-form";
import toast from "react-hot-toast";
import { validateEmail, classNames } from "@utilscommon";
import { renderFieldText, renderFieldSelect } from "@basecomponent";
import LocaleStrings from "@language";

import {
  openUserEditModal,
  updateUserDetails,
  fetchSingleOrder,
} from "@ticketsaction";

const UserDeatilsEdit = (props) => {
  const {
    session,
    isUserEditopen,
    orderdata,
    eventData,
    handleSubmit,
    pristine,
    invalid,
    submitting,
    countryList,
  } = props;
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    props.openUserEditModal(false);
  };

  const onSubmitForm = (data) => {
    // console.log("data :- ", data);
    setLoading(true);
    let data1 = {
      ordernumber: orderdata.data.orderid,
      eventid: eventData?.eventid,
    };
    data.id = orderdata?.data?.id;

    props.updateUserDetails(session, data, (response) => {
      if (response.success === 1) {
        props.fetchSingleOrder(session, data1, (res) => {
          if (res.success === 1) {
            setLoading(false);
            toast.success(LocaleStrings.kOrderBuyerInfoUpdateSuccess);
            closeModal();
          } else {
            setLoading(false);
            toast.error(LocaleStrings.kSomethingWentWrongMsg);
          }
        });
      } else if (response.success === 2) {
        setLoading(false);
        if (response?.error?.code === "email_required") {
          toast.error(LocaleStrings.kEmailRequiredText);
        } else if (response?.error?.code === "invalid_email") {
          toast.error(LocaleStrings.kInvalidEmail);
        } else if (response?.error?.code === "name_required") {
          toast.error(LocaleStrings.kBuyerNameRequiredText);
        } else if (response?.error?.code === "invalid_order") {
          toast.error(LocaleStrings.kInvalidOrderText);
        } else if (response?.error?.code === "buyer_info_not_updated") {
          toast.error(LocaleStrings.kSomethingWentWrongMsg);
        } else {
          toast.error(LocaleStrings.kSomethingWentWrongMsg);
        }
      } else {
        setLoading(false);
        toast.error(LocaleStrings.kSomethingWentWrongMsg);
      }
    });
  };

  return (
    <>
      <Transition.Root show={isUserEditopen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div>
                    <div className="">
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold leading-6 text-gray-900"
                      >
                        {LocaleStrings.kUpdateBuyerInfoText}
                      </Dialog.Title>
                      <div className="mt-4"></div>
                      <form onSubmit={handleSubmit(onSubmitForm)}>
                        <div className="base-form">
                          <Field
                            name="email"
                            label={LocaleStrings.kEmail}
                            placeholder={LocaleStrings.kEnterEmailAddress}
                            type="text"
                            component={renderFieldText}
                            mandatory={true}
                          />
                          <Field
                            name="username"
                            label={LocaleStrings.kLabelFullName}
                            placeholder={LocaleStrings.kPlaceholderFullName}
                            type="text"
                            component={renderFieldText}
                            mandatory={true}
                          />
                          <Field
                            name="vat"
                            label={LocaleStrings.kLabelVatNo}
                            placeholder={LocaleStrings.kPlaceholderVatNo}
                            type="text"
                            component={renderFieldText}
                          />
                          <Field
                            name="company_name"
                            label={LocaleStrings.kLabelBilledTo}
                            placeholder={LocaleStrings.kPlaceholderBilledTo}
                            type="text"
                            component={renderFieldText}
                          />
                          <Field
                            name="street"
                            label={LocaleStrings.kLabelStreet}
                            placeholder={LocaleStrings.kPlaceholderStreet}
                            type="text"
                            component={renderFieldText}
                          />
                          <Field
                            name="city"
                            label={LocaleStrings.kLabelCity}
                            placeholder={LocaleStrings.kPlaceholderCity}
                            type="text"
                            component={renderFieldText}
                          />
                          <Field
                            name="postal"
                            label={LocaleStrings.kLabelPostal}
                            placeholder={LocaleStrings.kPlaceholderPostal}
                            type="text"
                            component={renderFieldText}
                          />
                          <Field
                            name="country"
                            label={LocaleStrings.kCountryText}
                            placeholder={LocaleStrings.kPlaceholderCountry}
                            component={renderFieldSelect}
                            options={_.map(countryList, (e) => ({
                              value: e.country,
                              text: e.country,
                            }))}
                          />
                        </div>
                        <div className="text-center mt-6">
                          <button
                            type="submit"
                            className="theme-button-md"
                            disabled={
                              pristine || invalid || submitting || loading
                            }
                          >
                            <svg
                              className={classNames(
                                loading ? "" : "hidden",
                                "cust-btn-spinner"
                              )}
                              viewBox="0 0 1024 1024"
                              focusable="false"
                              data-icon="btnloading"
                              width="1em"
                              height="1em"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                            </svg>{" "}
                            {LocaleStrings.kUpdateDetailsText}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

const validate = (values, ownProps) => {
  let errors = {};
  let email = values.email;
  let username = values.username;
  if (!email || email.trim() === "") {
    errors[`email`] = LocaleStrings.kFieldRequired;
  } else if (email && !validateEmail(email)) {
    errors[`email`] = LocaleStrings.kInvalidEmail;
  }
  if (!username || username.trim() === "") {
    errors["username"] = LocaleStrings.kFieldRequired;
  }
  // console.log("errors :- ", errors);
  return errors;
};

const mapStateToProps = (state) => {
  let initval = {};
  if (state.orderData && state.orderData?.data) {
    let orderdata = state.orderData?.data;
    initval.email = orderdata?.email;
    initval.username = orderdata?.username;
    initval.vat = orderdata?.vat;
    initval.company_name = orderdata?.company_name;
    initval.street = orderdata?.street;
    initval.city = orderdata?.city;
    initval.postal = orderdata?.postal;
    initval.country = orderdata?.country;
  }
  return {
    session: state.session,
    isUserEditopen: state.isUserEditopen,
    initialValues: initval,
    orderdata: state.orderData,
    eventData: state.eventData,
    countryList: state.countryList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      openUserEditModal,
      updateUserDetails,
      fetchSingleOrder,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "UserDetailsEditForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(UserDeatilsEdit)
);
